import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { MediaChromeSelectMenu } from "./media-chrome-selectmenu.js";
import "./media-rendition-button.js";
import "./media-rendition-listbox.js";
import { MediaUIAttributes } from "../constants.js";
import { globalThis, document } from "../utils/server-safe-globals.js";

var MediaRenditionSelectMenu = /*#__PURE__*/function (_MediaChromeSelectMen) {
  _inherits(MediaRenditionSelectMenu, _MediaChromeSelectMen);

  var _super = _createSuper(MediaRenditionSelectMenu);

  function MediaRenditionSelectMenu() {
    _classCallCheck(this, MediaRenditionSelectMenu);

    return _super.apply(this, arguments);
  }

  _createClass(MediaRenditionSelectMenu, [{
    key: "init",
    value: function init() {
      var renditionButton = document.createElement("media-rendition-button");
      renditionButton.part.add("button");
      renditionButton.preventClick = true;
      var renditionListbox = document.createElement("media-rendition-listbox");
      renditionListbox.part.add("listbox");
      renditionListbox.setAttribute("exportparts", "option, option-selected, indicator");
      var buttonSlot = this.shadowRoot.querySelector("slot[name=button]");
      var listboxSlot = this.shadowRoot.querySelector("slot[name=listbox]");
      buttonSlot.textContent = "";
      listboxSlot.textContent = "";
      buttonSlot.append(renditionButton);
      listboxSlot.append(renditionListbox);
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return [].concat(_toConsumableArray(_get(_getPrototypeOf(MediaRenditionSelectMenu), "observedAttributes", this)), [MediaUIAttributes.MEDIA_RENDITION_SELECTED, MediaUIAttributes.MEDIA_RENDITION_UNAVAILABLE]);
    }
  }]);

  return MediaRenditionSelectMenu;
}(MediaChromeSelectMenu);

if (!globalThis.customElements.get("media-rendition-selectmenu")) {
  globalThis.customElements.define("media-rendition-selectmenu", MediaRenditionSelectMenu);
}

var media_rendition_selectmenu_default = MediaRenditionSelectMenu;
export { MediaRenditionSelectMenu, media_rendition_selectmenu_default as default };